import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss'],
  standalone: false
})
export class AccessibilityComponent implements OnInit {

  @Input() public tooltipDisabled: boolean = true;

  // Controle de fonte
  private baseSize: number = 14; // tamanho base em px
  private step: number = 2;      // incremento em px
  public fontLevel: number = 0;  // vai de -2 até +2

  // Uppercase / Capitalize
  @Input() public selectedUpper: boolean = true;

  // Contraste
  @Input() public selectedConstrast: boolean = false;

  // Cores dos ícones
  @Input() public iconColor!: string;
  @Input() public selectedColor!: string;

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    this.setBaseFontByScreen();
    this.loadFontSettings();
    this.setStylingUpperCase();
    this.setStylingContrast();
  }

  // -------------------------
  // CONTROLE DE FONTE
  // -------------------------

  increaseFont(): void {
    if (this.isMaxFont()) {
      return;
    }
  
    this.fontLevel++;
    this.applyFontSize();
  }
  
  decreaseFont(): void {
    if (this.isMinFont()) {
      return;
    }
  
    this.fontLevel--;
    this.applyFontSize();
  }
  
  private setBaseFontByScreen(): void {

    const width = window.innerWidth;
  
    // mobile
    if (width <= 576) {
      this.baseSize = 12;
    }
  
    // tablet
    else if (width <= 768) {
      this.baseSize = 13;
    }
  
    // desktop
    else {
      this.baseSize = 14;
    }
  
  }
  private applyFontSize(): void {

    const scale = 1 + (this.fontLevel * 0.15);
  
    document.documentElement.style.setProperty('--font-scale', `${scale}`);
  
    this.cookieService.set('_gord_fontLevel', String(this.fontLevel));
  }

  private loadFontSettings(): void {

    // Se ainda existir cookie antigo de tamanho, remove para evitar conflito
    if (this.cookieService.check('_gord_fontSize')) {
      this.cookieService.delete('_gord_fontSize');
    }
  
    // Se não existir nível salvo, força nível 0 (tamanho padrão)
    if (!this.cookieService.check('_gord_fontLevel')) {
      this.fontLevel = 0;
      this.cookieService.set('_gord_fontLevel', '0');
    } else {
      this.fontLevel = Number(this.cookieService.get('_gord_fontLevel'));
    }
  
    this.applyFontSize();
  }
  

  // -------------------------
  // UpperCase / Capitalize
  // -------------------------

  toggleUpperCaseIcon(): void {
    this.selectedUpper = !this.selectedUpper;
    this.cookieService.set('_gord_selectedUpper', String(this.selectedUpper));
    this.setStylingUpperCase();
  }

  setStylingUpperCase(): void {
    this.selectedUpper = this.cookieService.get('_gord_selectedUpper') !== 'false';

    const root = document.documentElement;

    root.style.setProperty(
      '--uppercase',
      this.selectedUpper ? 'uppercase' : 'capitalize'
    );
  }

  // -------------------------
  // CONTRASTE
  // -------------------------

  toggleConstrastIcon(): void {
    this.selectedConstrast = !this.selectedConstrast;
    this.cookieService.set('_gord_selectedConstrast', String(this.selectedConstrast));
    this.setStylingContrast();
  }

  setStylingContrast(): void {
    this.selectedConstrast = this.cookieService.get('_gord_selectedConstrast') === 'true';

    document.body.style.filter = this.selectedConstrast
      ? "hue-rotate(180deg)"
      : "initial";
  }
    // Verifica se já está no menor nível
    isMinFont(): boolean {
      return this.fontLevel <= -2;
    }

    // Verifica se já está no maior nível
    isMaxFont(): boolean {
      return this.fontLevel >= 2;
    }


}
